
import React from "react";
import { Classname } from "@rivtn/noseur";
import { indexTag } from "../../helpers";
import styles from "../../assets/style.module.css";

export interface AccordionItemProps {
    index: number;
    open: boolean;
    title: React.ReactNode;
    meta?: React.ReactNode;
    children: React.ReactNode;
    onToggle: () => void;
}

function AccordionItem({ index, open, title, meta, children, onToggle }: AccordionItemProps) {

    const id = React.useId();

    return (<div className={Classname.build(styles["acc-item"], { [styles["open"]]: open })}>
        <button className={styles["acc-header"]} onClick={onToggle} aria-expanded={open} aria-controls={id}>
            <span className={Classname.build(styles["tag"], styles["acc-no"])}>{indexTag(index)}</span>
            <span className={styles["acc-title"]}>{title}</span>
            {meta && (<span className={styles["acc-meta"]}>{meta}</span>)}
            <span className={styles["acc-icon"]}><i className="fa fa-plus" /></span>
        </button>
        <div id={id} className={styles["acc-body-wrap"]} role="region">
            <div className={styles["acc-body"]}>{children}</div>
        </div>
    </div>);
}

export default AccordionItem;
